import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/employees';
const filter = (filter) => filter ? 'filter=' + filter : '';

const state = {
    employees: [],
    employee: null,
};
const getters = {
    employees: (state) => state.employees,
    employee: (state) => state.employee,
};
const actions = {
    /**
     * @todo remove see /views/delme.OfferCreateDebug
     */
    async fetchEmployees({ commit }, search) {
        const response = await axios.get(API_URL + '?' + filter(search));
        commit('setEmployees', response.data.items);
    },
    async fetchEmployee({ commit }, email) {
        const response = await axios.get(API_URL + '/' + email + '/by-email');
        commit('setEmployee', response.data);
    }
};
const mutations = {
    setEmployees: (state, employees) => state.employees = employees,
    setEmployee: (state, employee) => state.employee = employee,
};

export default {
    state,
    getters,
    actions,
    mutations,
};